import type { ICurrentUserMe } from '../services/users';
import { getDefaultHomePath } from './isProfile';

/** Destino padrão dos CTAs de erro (404 / início) conforme perfil. */
export function getDefaultErrorHomePath(user: ICurrentUserMe | null): string {
  return getDefaultHomePath(user ?? undefined);
}

const AUTHENTICATED_PATH_PREFIXES = [
  '/admin',
  '/consultant',
  '/dashboard',
  '/quotes',
  '/myAccount',
  '/chat',
] as const;

/** Rotas que devem cair no router autenticado (inclui 404 com shell). */
export function isAuthenticatedAppPath(pathname: string): boolean {
  return AUTHENTICATED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}
